<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible="visible"
      append-to-body
      width="1000px"
      top="10vh"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => close()"
    >
      <DetailForm :orderPackageCode="orderPackageCode" @close="close()" />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DetailForm from './index.vue'
export default {
  components: { DetailForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderPackageCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
